"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToJSONSchema = exports.json = void 0;
var zod_1 = require("zod");
var literalSchema = zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.null()]);
var jsonSchema = zod_1.z.lazy(function () { return zod_1.z.union([literalSchema, zod_1.z.array(jsonSchema), zod_1.z.record(jsonSchema)]); });
var json = function () { return jsonSchema; };
exports.json = json;
exports.stringToJSONSchema = zod_1.z.string().transform(function (str, ctx) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        ctx.addIssue({ code: 'custom', message: 'Invalid JSON' });
        return zod_1.z.NEVER;
    }
});
